__turbopack_context__.v({
  "authorAvatar": "StatsAndTestimonials-module__snT9oG__authorAvatar",
  "authorMeta": "StatsAndTestimonials-module__snT9oG__authorMeta",
  "authorName": "StatsAndTestimonials-module__snT9oG__authorName",
  "authorRole": "StatsAndTestimonials-module__snT9oG__authorRole",
  "authorRow": "StatsAndTestimonials-module__snT9oG__authorRow",
  "barContainer": "StatsAndTestimonials-module__snT9oG__barContainer",
  "barFill": "StatsAndTestimonials-module__snT9oG__barFill",
  "cardTitle": "StatsAndTestimonials-module__snT9oG__cardTitle",
  "chartDropdown": "StatsAndTestimonials-module__snT9oG__chartDropdown",
  "chartHeader": "StatsAndTestimonials-module__snT9oG__chartHeader",
  "chartSvg": "StatsAndTestimonials-module__snT9oG__chartSvg",
  "chartWrapper": "StatsAndTestimonials-module__snT9oG__chartWrapper",
  "chartXLabels": "StatsAndTestimonials-module__snT9oG__chartXLabels",
  "dashboardCard": "StatsAndTestimonials-module__snT9oG__dashboardCard",
  "dot": "StatsAndTestimonials-module__snT9oG__dot",
  "dotActive": "StatsAndTestimonials-module__snT9oG__dotActive",
  "dots": "StatsAndTestimonials-module__snT9oG__dots",
  "fillGreen": "StatsAndTestimonials-module__snT9oG__fillGreen",
  "fillPrimary": "StatsAndTestimonials-module__snT9oG__fillPrimary",
  "fillPurple": "StatsAndTestimonials-module__snT9oG__fillPurple",
  "grid": "StatsAndTestimonials-module__snT9oG__grid",
  "hotelName": "StatsAndTestimonials-module__snT9oG__hotelName",
  "progressGrid": "StatsAndTestimonials-module__snT9oG__progressGrid",
  "progressInfo": "StatsAndTestimonials-module__snT9oG__progressInfo",
  "progressRow": "StatsAndTestimonials-module__snT9oG__progressRow",
  "progressSection": "StatsAndTestimonials-module__snT9oG__progressSection",
  "quoteCard": "StatsAndTestimonials-module__snT9oG__quoteCard",
  "quoteIconWrapper": "StatsAndTestimonials-module__snT9oG__quoteIconWrapper",
  "quoteText": "StatsAndTestimonials-module__snT9oG__quoteText",
  "slide": "StatsAndTestimonials-module__snT9oG__slide",
  "slideActive": "StatsAndTestimonials-module__snT9oG__slideActive",
  "sliderContainer": "StatsAndTestimonials-module__snT9oG__sliderContainer",
  "statCell": "StatsAndTestimonials-module__snT9oG__statCell",
  "statLabel": "StatsAndTestimonials-module__snT9oG__statLabel",
  "statTrend": "StatsAndTestimonials-module__snT9oG__statTrend",
  "statVal": "StatsAndTestimonials-module__snT9oG__statVal",
  "statsRow": "StatsAndTestimonials-module__snT9oG__statsRow",
  "statsSection": "StatsAndTestimonials-module__snT9oG__statsSection",
  "svgContainer": "StatsAndTestimonials-module__snT9oG__svgContainer",
  "testimonialColumn": "StatsAndTestimonials-module__snT9oG__testimonialColumn",
  "trendUp": "StatsAndTestimonials-module__snT9oG__trendUp",
});
